import PdImage from '../../../components/pd-image/pd-image'
import { useD9 } from '../../../hooks/use-d9-data'

export function Section3() {
  const { section3 } = useD9()

  return (
    <div className="w-full h-fit laptop:px-0 px-6 laptop:py-30 py-15 bg-black">
      <div className="w-300 max-w-full mx-auto">
        <div className="w-full flex flex-col laptop:gap-6 gap-3 laptop:items-center items-start">
          <h2 className="text-white/90 laptop:text-5xl text-2xl font-semibold">{section3.title}</h2>
          <h3 className="text-white/90 text-base laptop:text-lg font-normal">{section3.subTitle}</h3>
        </div>
        <div className="w-full flex flex-col laptop:flex-row mt-8 laptop:mt-16 laptop:gap-y-8 gap-y-3">
          <figure className="relative w-full laptop:w-588px h-350px laptop:h-900px">
            <PdImage src={section3.robotFrontImage} width="100%" height="100%" object="contain" objectPosition="top" />
          </figure>
          <figure className="relative w-full laptop:w-588px h-350px laptop:h-900px">
            <PdImage src={section3.robotBackImage} width="100%" height="100%" object="contain" objectPosition="top" />
          </figure>
        </div>
        <div className="mt-8 laptop:mt-16 laptop:ml-30">
          <dl className="laptop:w-240 mx-auto max-w-full grid grid-cols-2 laptop:grid-cols-3 gap-x-3 laptop:gap-x-0 gap-y-8 laptop:gap-y-16">
            {section3.spec.map((item) => {
              return (
                <div key={item[0]}>
                  <dd className="text-white/90 text-[1.75rem] laptop:text-42 font-['Montserrat'] font-bold">
                    {item[1]}
                  </dd>
                  <dt className="mt-1 laptop:mt-2 text-white/60 text-sm laptop:text-base font-normal">{item[0]}</dt>
                </div>
              )
            })}
          </dl>
        </div>
      </div>
    </div>
  )
}
